<button
  type="button"
  class="filter-button-base"
  [disabled]="disabled()"
  [class]="{
    'button-large': size() === InputSize.large,
    'button-small': size() === InputSize.small,
    'filter-button-active': (badgeCount() ?? 0) > 0,
  }"
  (click)="buttonClick.emit()">
  <div class="d-flex justify-content-center align-items-center">
    <mat-icon [hidden]="hideLeadingIcon()" class="filter-button-icon" [svgIcon]="'filter'"></mat-icon>
    <div class="button-title">
      <ng-content></ng-content>
    </div>
    @if (badgeCount()) {
      <div class="filter-badge">
        {{ badgeCount() }}
      </div>
    }
  </div>
</button>
